import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "../api/axiosInstance";

export default function AdminDeliveryBoyMap() {
  const { boyId } = useParams();

  const [location, setLocation] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  const fetchLocation = async () => {
    try {
      const res = await axios.get(
        `admin/delivery-boy-location/${boyId}/`
      );
      setLocation(res.data);
      setError("");
    } catch (err) {
      if (err.response?.status === 404) {
        setError("Delivery boy location not available yet");
      } else {
        setError("Failed to fetch delivery boy location");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLocation();
    const interval = setInterval(fetchLocation, 5000); // live tracking
    return () => clearInterval(interval);
  }, []);

  if (loading) return <p style={{ padding: 20 }}>Loading map...</p>;

  if (error)
    return (
      <div style={{ padding: 20 }}>
        <p style={{ color: "red" }}>{error}</p>
        <p>Waiting for delivery boy GPS update...</p>
      </div>
    );

  return (
    <div style={{ padding: 20 }}>
      <h2>📍 Live Delivery Boy Location</h2>

      <p>
        <b>{location.name}</b> ({location.phone})
      </p>
<p>
  Lat: {location.lat} | Lng: {location.lng}
</p>
      <iframe
        title="Live Map"
        width="100%"
        height="500"
        frameBorder="0"
        style={{ borderRadius: 10 }}
        src={`https://www.google.com/maps?q=${location.lat},${location.lng}&z=15&output=embed&t=${Date.now()}`}
        allowFullScreen
      />
    </div>
  );
}
